<template>
    <div>
        <data-table v-if="showView === 'listpage'" ref="dataTable" class="dataTable" :module-info="moduleInfo" :tb-columns="tbColumns" :toolbar-btns="listpageBtns" :on-list-data-before-load="onListDataBeforeLoad" :show-toolbar="0" :on-list-data-loaded="onListDataLoaded" :on-cell-click="cellclick" :on-selected-rows-change="selectedRowsChange">
            <slot slot="top">
                <div style="">
                    <div class="dragpanel-container">
                        <form class="el-form">
                            <div class="el-table el-table--fit el-table--border" style="100%">
                                <div class="el-table__body-wrapper">
                                    <table cellspacing="0" cellpadding="0" border="0" class="el-table__body el-table__body-no">
                                        <tbody>

                                            <tr>
                                                <td class="el-table__cell tdlbl tdw17" colspan="1">项目名称</td>
                                                <td class="el-table__cell tdcont tdw17" colspan="1">
                                                    <el-input v-model="searchMap.flSubject" placeholder="请输入项目名称" />
                                                </td>

                                                <td class="el-table__cell tdlbl tdw17" colspan="1">合同签订日期(开始)</td>
                                                <td class="el-table__cell tdcont tdw17" colspan="1">
                                                    <el-date-picker v-model="searchMap.contractDate_START" style="width: 100%" :format="'yyyy-MM-dd HH:mm'" value-format="yyyy-MM-dd HH:mm" type="datetime" :placeholder="'合同签订日期(开始)'" />
                                                </td>
                                                <td class="el-table__cell tdlbl tdw17" colspan="1">合同签订日期(结束)</td>
                                                <td class="el-table__cell tdcont tdw17" colspan="1">
                                                    <el-date-picker v-model="searchMap.contractDate_END" style="width: 100%" :format="'yyyy-MM-dd HH:mm'" value-format="yyyy-MM-dd HH:mm" type="datetime" :placeholder="'合同签订日期(结束)'" />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="el-table__cell tdlbl tdw17" colspan="1">招标类型</td>
                                                <td class="el-table__cell tdcont tdw33" colspan="2">
                                                    <el-select v-model="searchMap.zbType" style="width: 100%" placeholder="请选择招标类型">
                                                        <el-option v-for="item in zbTypeOption" :key="item.value" :label="item.label" :value="item.value"></el-option>
                                                    </el-select>
                                                </td>
                                                <td class="el-table__cell tdlbl tdw17" colspan="1">采购方式</td>
                                                <td class="el-table__cell tdcont tdw33" colspan="2">
                                                    <el-select v-model="searchMap.zbWay" style="width: 100%" placeholder="请选择采购方式">
                                                        <el-option v-for="item in zbWayOption" :key="item.value" :label="item.label" :value="item.value"></el-option>
                                                    </el-select>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="el-table__cell tdlbl tdw17" colspan="1">中标价格(开始)</td>
                                                <td class="el-table__cell tdcont tdw33" colspan="2">
                                                    <el-input v-model="urlsearchMap.cjAmountStart" type="number" placeholder="请输入中标价格(开始)" />
                                                </td>
                                                <td class="el-table__cell tdlbl tdw17" colspan="1">中标价格(结束)</td>
                                                <td class="el-table__cell tdcont tdw33" colspan="2">
                                                    <el-input v-model="urlsearchMap.cjAmountEnd" type="number" placeholder="请输入中标价格(结束)" />
                                                </td>
                                            </tr>

                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </form>
                        <div class="panel-footer" style="padding: 10px; text-align: center">
                            <button type="button" class="el-button el-button--default el-button--medium color" @click="submitSearch">
                                <i class="el-icon-search" />
                                <span>开始搜索</span>
                            </button>
                            <button type="button" class="el-button el-button--default el-button--medium" @click="resetSearch">
                                <i class="el-icon-close" />
                                <span>清除搜索</span>
                            </button>
                        </div>
                    </div>
                </div>
            </slot>
        </data-table>
    </div>
</template>

<script>
export default {
    components: {},
    props: {
        // 通用属性
        vo: {
            type: Object,
            default: function () {
                return {}
            }
        },
        canEdit: { type: Number, default: 1 },
        activeTab: { type: String, default: ''},
        oldDataType: { type: String, default: ''}
    },
    data() {
        return {
            moduleInfo: { formTemplate: 'dcontent/busiformurl?vwtype=W&url=/zbgl/jggd/form.html', addNewUrl: 'zbgl/jggd/addNew', insertUrl: 'zbgl/jggd/insert', getByIdUrl: 'zbgl/jggd/getById', updateUrl: 'zbgl/jggd/update', delUrl: 'zbgl/jggd/delete', listDataUrl: 'zbgl/zbxmArch/listdata?urlsearch=borrowStatus:1' + ';oldDataType:' + this.oldDataType + '&listpageId=5e25ad5dbeb248abb6ddbdb270ae8e15', winWidth: 1000, winHeight: 600, moduleCode: 'jggd', openViewType: '0', listAdvSearchAllFields: 0, listAdvSearchExpandPanel: 0 },
            tbColumns: [
                { field: 'state', checkbox: true, width: '45px', align: 'center', sortable: false, fixed: 'false' },
                { align: 'center', field: 'index', title: '序号', width: '45px', sortable: false, fixed: 'false', listAdvSearchElement: '', searchable: false, propType: '' },
                { align: 'center', field: 'projectCode', title: '公司统一编号', width: '150px', sortable: true, listAdvSearchElement: 'input', searchable: true, listAdvSearchIndex: 0, propType: 'String' },
                { align: 'left', field: 'flSubject', title: '项目名称', width: '200px', sortable: true, fixed: 'false', listTdEdit: 0, listAdvSearchElement: 'input', searchable: true, listAdvSearchIndex: 1, propType: 'String' },
                { align: 'center', field: 'contractDate', title: '合同签订日期', width: '150px', sortable: true, fixed: 'false', listTdEdit: 0, listAdvSearchElement: 'date', searchable: true, listAdvSearchIndex: 2, propType: 'java.util.Date', propFormatter: 'format：yyyy年MM月dd日' },
                { align: 'center', field: 'zbFzr', title: '合同签订项目负责人', width: '180px', sortable: true, fixed: 'false', listTdEdit: 0, listAdvSearchElement: 'input', searchable: true, listAdvSearchIndex: 3, propType: 'String' },
                { align: 'center', field: 'zbAmount', title: '投资金额（元）', width: '160px', sortable: true, fixed: 'false', listTdEdit: 0, listAdvSearchElement: 'input', searchable: true, listAdvSearchIndex: 4, propType: 'java.math.BigDecimal' },
                { align: 'center', field: 'webSite', title: '公告发布网站地址', width: '150px', sortable: false, fixed: 'false', listTdEdit: 0, listAdvSearchElement: '', searchable: false, propType: 'String' },
                { align: 'center', field: 'zbFzrPhone', title: '联系方式', width: '150px', sortable: true, fixed: 'false', listTdEdit: 0, listAdvSearchElement: 'input', searchable: true, listAdvSearchIndex: 5, propType: 'String' },
                { align: 'center', field: 'zbXmbh', title: '招标编号', width: '150px', sortable: true, fixed: 'false', listTdEdit: 0, listAdvSearchElement: 'input', searchable: true, listAdvSearchIndex: 6, propType: 'String' },
                { align: 'center', field: 'zbType', title: '招标类型', width: '120px', sortable: true, fixed: 'false', listTdEdit: 0, listAdvSearchElement: 'select', searchable: true, listAdvSearchIndex: 7, propType: 'Short', elementFormatter: '1：工程\n2：货物\n3：服务\n4：施工' },
                { align: 'center', field: 'archivedBy', title: '姓名', width: '120px', sortable: true, fixed: 'false', listTdEdit: 0, listAdvSearchElement: 'input', searchable: true, listAdvSearchIndex: 8, propType: 'String' },
                { align: 'center', field: 'archivedDate', title: '中标通知书日期', width: '150px', sortable: true, fixed: 'false', listTdEdit: 0, listAdvSearchElement: 'date', searchable: true, listAdvSearchIndex: 9, propType: 'java.util.Date', elementFormatter: 'format：yyyy年MM月dd日\r\n' },
                { align: 'center', field: 'zbWay', title: '采购方式', width: '120px', sortable: true, fixed: 'false', listTdEdit: 0, listAdvSearchElement: 'select', searchable: true, listAdvSearchIndex: 10, propType: 'Short', elementFormatter: '1：公开招标\n2：邀请招标\n3：竞争性谈判\n4：询价\n5：单一来源\n6：竞争性磋商\n7：框架协议' },
                { align: 'center', field: 'cjAmount', title: '中标价格（元）', width: '150px', sortable: true, fixed: 'false', listTdEdit: 0, listAdvSearchElement: 'input', searchable: true, listAdvSearchIndex: 11, propType: 'java.math.BigDecimal' },
                // { align: 'center', field: 'wfNodeNames', title: '处理环节', width: '120px', sortable: true, listAdvSearchElement: '', searchable: false, listAdvSearchIndex: 12, propType: 'String' },
                { enabled: false, align: 'left', field: 'flSubject', title: '申请事由', width: '100px', sortable: false, listAdvSearchElement: '', searchable: false, propType: 'String' },
                { enabled: false, align: 'left', field: 'flCreateDept', title: '申请部门', width: '100px', sortable: false, listAdvSearchElement: '', searchable: false, propType: 'String' },
                { enabled: false, align: 'center', field: 'flCreateDate', title: '申请日期', width: '110px', sortable: false, listAdvSearchElement: '', searchable: false, propType: 'java.util.Date', elementFormatter: 'format：yyyy年MM月dd日\r\n' },
                { enabled: false, align: 'center', field: 'flCreator', title: '申请人', width: '85px', sortable: false, listAdvSearchElement: '', searchable: false, propType: 'String' },
                { enabled: false, align: 'left', field: 'orgName', title: '机构名称', width: '100px', sortable: false, listAdvSearchElement: '', searchable: false, propType: 'String' },
                { enabled: false, align: 'center', field: 'status', title: '状态', width: '75px', sortable: false, listAdvSearchElement: '', searchable: false, propType: 'Short', elementFormatter: '0：草稿\r\n1：处理中\r\n2：结束\r\n8：已归档\r\n9：已注销\r\n' }
            ],
            listpageBtns: [],
            loginUser: this.$store.getters.loginUser,
            listStyle: {},
            showView: 'listpage',
            zbTypeOption: [
                {
                    label: '工程',
                    value: 1
                },
                {
                    label: '货物',
                    value: 2
                },
                {
                    label: '服务',
                    value: 3
                },
                {
                    label: '施工',
                    value: 4
                }
            ],
            zbWayOption: [
                {
                    label: '公开招标',
                    value: 1
                },
                {
                    label: '邀请招标',
                    value: 2
                },
                {
                    label: '竞争性谈判',
                    value: 3
                },
                {
                    label: '询价',
                    value: 4
                },
                {
                    label: '单一来源',
                    value: 5
                },
                {
                    label: '竞争性磋商',
                    value: 6
                },
                {
                    label: '框架协议',
                    value: 7
                }
            ],
            searchMap: {
                flSubject: '',
                contractDate_START: '',
                contractDate_END: '',
                zbType: '',
                zbWay: ''
            },
            urlsearchMap: {
                cjAmountStart: '',
                cjAmountEnd: ''
            }
        }
    },
    computed: {},
    watch: {},
    created() {},
    beforeDestroy() {},
    mounted() {
        this.submitSearch()
    },
    methods: {
        resetSearch() {
            this.searchMap = {
                projectName: '',
                contractDate_START: '',
                contractDate_END: '',
                zbType: '',
                zbWay: ''
            }
            this.urlsearchMap = {
                cjAmountStart: '',
                cjAmountEnd: ''
            }

            this.$nextTick(() => {
                this.$bus.emit('refreshListData')
            })
        },
        submitSearch() {
            console.log(this.$refs.dataTable, '  this.$refs.dataTable')
            this.$refs.dataTable.searchMap = this.searchMap
            this.$refs.dataTable.searchAndOr = 'AND'
            if (this.urlsearchMap.cjAmountStart || this.urlsearchMap.cjAmountEnd) {
                this.moduleInfo.listDataUrl = 'zbgl/zbxmArch/listdata?urlsearch=borrowStatus:1' + ';oldDataType:' + this.oldDataType + '&listpageId=5e25ad5dbeb248abb6ddbdb270ae8e15' + 'cjAmountStart=' + this.urlsearchMap.cjAmountStart + '&cjAmountEnd =' + this.urlsearchMap.cjAmountEnd + '&urlsearch=borrowStatus:1'
            } else {
                this.moduleInfo.listDataUrl = 'zbgl/zbxmArch/listdata?urlsearch=borrowStatus:1' + ';oldDataType:' + this.oldDataType + '&listpageId=5e25ad5dbeb248abb6ddbdb270ae8e15'
            }
            this.$nextTick(() => {
                this.$bus.emit('refreshListData')
            })
        },
        selectedRowsChange(row) {
            this.$bus.emit('selectRow', row) // 传给借阅申请的子表
        },
        cellclick(row) {
            console.log(row, 'row')
            this.$http({
                url: 'zbgl/zbxmArch/listdata',
                method: 'post',
                params: {
                    urlsearch: 'projectCode:' + row.projectCode
                },
                contentType: 'application/x-www-form-urlencoded'
            }).then((res) => {
                const linkrow = res.body.pageInfo.list[0]
                window.open('#/zbtzView?wfEngineUrl=zbgl/zbxmArch&busiDataId=' + linkrow.id + '&logoTitle=' + encodeURIComponent('招标管理/' + linkrow.flSubject) + '&type=' + 'attachment' + '&canEdit=' + (this.vo.status === 2 ? '1' : '0'))
            })
        }
    },
    /**
     * 加载数据完成，pageInfo为包含查询结果的分页信息对象，不需要返回值
     */
    onListDataLoaded: function ($scope, pageInfo) {
        console.log('fgsgl listdata loaded', $scope, pageInfo)
    },
    /**
     * 加载数据准备，qparams为查询参数对象，不需要返回值
     */
    onListDataBeforeLoad: function ($scope, qparams) {
        // qparams.listpageId = 'cf2b5768c86b4cc6a118bb7dbd1b5fc8'
        // qparams.urlsearch = 'borrowStatus:1'
        console.log('fgsgl listdata before load..', $scope, qparams)
    }
}
</script>

<style scoped lang="scss"></style>
